import * as React from 'react';
import { FormField, Select, SpaceBetween } from '@amzn/awsui-components-react-v3';
import { EmptyState } from 'src/commons/EmptyState';

export interface GalaxiGroupDropdownProps {
  selectedOption: any;
  onChange: any;
  options: any;
  errorText?: string;
}

export const GalaxiGroupDropdown = (props: GalaxiGroupDropdownProps) => {
  return (
    <FormField
      label='Target Galaxi group'
      description='Select the target Galaxi group for your subscription request.'
      errorText={props.errorText}
    >
      <SpaceBetween size='m'>
        <Select
          selectedOption={props.selectedOption}
          onChange={props.onChange}
          empty={
            <EmptyState
              title='No Galaxi groups found matching this account'
              subtitle='To subscribe to this dataset, you must first onboard on the Galaxi platform.'
            />
          }
          options={props.options}
          selectedAriaLabel='Selected'
          loadingText='Loading access options'
        />
      </SpaceBetween>
    </FormField>
  );
};
